import { useRouter } from 'next/router';

import { RichText } from '@components/RichText';
import { SideNav } from '@components/SideNav';

import { CmsLegalPageDocument, SideNavSection } from '@interfaces/common';

import styles from './LegalPage.module.css';

export interface LegalPageProps {
	legalPage: CmsLegalPageDocument;
	sideNavData: SideNavSection[];
}

export const LegalPage: React.VFC<LegalPageProps> = ({
	legalPage,
	sideNavData,
}) => {
	const { content } = legalPage;
	const { asPath } = useRouter();

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.nav}>
					<SideNav activeHref={asPath} sections={sideNavData} />
				</div>
				<div>
					<RichText value={content} />
				</div>
			</div>
		</>
	);
};
